import { useTranslation } from "react-i18next";
import { X } from "lucide-react";
import { Button } from "./Button";
import { useToasts } from "./toasts";

export function Toasts() {
  const { t } = useTranslation();
  const toasts = useToasts((s) => s.toasts);
  const dismiss = useToasts((s) => s.dismiss);
  if (!toasts.length) return null;
  return (
    <div
      className="pointer-events-none fixed bottom-4 right-4 z-50 flex w-96 max-w-[calc(100vw-2rem)] flex-col gap-2"
      role="region"
      aria-label={t("toasts.region")}
    >
      {toasts.map((toast) => (
        <div
          key={toast.id}
          role="status"
          data-testid="toast"
          className="pointer-events-auto flex items-center gap-3 rounded-lg border border-neutral-200 bg-[var(--surface)] px-4 py-3 text-sm shadow-[var(--shadow-md)] dark:border-neutral-700"
        >
          <span className="min-w-0 flex-1">{toast.text}</span>
          {toast.action && (
            <Button
              variant="secondary"
              size="sm"
              onClick={() => {
                toast.action!.run();
                dismiss(toast.id);
              }}
            >
              {toast.action.label}
            </Button>
          )}
          <button
            type="button"
            aria-label={t("common.close")}
            onClick={() => dismiss(toast.id)}
            className="grid h-6 w-6 place-items-center rounded-sm text-neutral-500 hover:bg-neutral-100 dark:hover:bg-neutral-800"
          >
            <X size={14} aria-hidden />
          </button>
        </div>
      ))}
    </div>
  );
}
